import HttpClient from '@/util/http/HttpClient';
import { Observable } from 'rxjs';
import stringifyObject from 'stringify-object';
import stringifyGlossOrdering from '@/api/graph/stringifyGlossOrdering';
import GraphQlResponse from '@/api/graph/GraphQlResponse';
import GlossFilter from '@/api/graph/GlossFilter';
import GlossOrdering from '@/api/graph/GlossOrdering';
import GlossSearchResult from '@/api/graph/GlossSearchResult';
import GraphQlConnection from '@/api/graph/GraphQlConnection';
import GlossMediaResult from '@/api/graph/GlossMediaResult';

export default class GraphQlApi {
    private readonly client: HttpClient;
    private readonly baseUrl: string;

    public constructor(client: HttpClient, apiEndpoint: string) {
        this.client = client;
        this.baseUrl = apiEndpoint + '/graphql/';
    }

    public getGlossesPage(
        first: number,
        after: string | null,
        where: GlossFilter,
        orderBy: GlossOrdering | null,
    ): Observable<GraphQlResponse<GraphQlConnection<GlossSearchResult>, 'glossesConnection'>> {
        const whereClause = stringifyObject(where, { singleQuotes: false });
        const afterLine = after !== null ? `after: "${after}",` : '';
        const orderByLine = orderBy !== null ? 'orderBy: ' + stringifyGlossOrdering(orderBy) : '';
        const queryBody = {
            operationName: 'GetGlossesCn',
            query: `
                    query GetGlossesCn {
                        glossesConnection(
                            product: MJEGB,
                            first: ${first}, ${afterLine}
                            where: ${whereClause}
                            ${orderByLine}
                        ) {
                            edges {
                                node {
                                    id
                                    name
                                    keywords
                                }
                            }
                            pageInfo {
                                endCursor
                                totalNodeCount
                                totalPageCount
                            }
                        }
                    }
                `.replace(' ', ''),
            variables: {},
        };
        return this.client.post(this.baseUrl, queryBody);
    }

    public getGlossMedia(where: GlossFilter): Observable<GraphQlResponse<GlossMediaResult, 'gloss'>> {
        const whereClause = stringifyObject(where, { singleQuotes: false });
        const queryBody = {
            operationName: 'GetGlossMedia',
            query: `
                    query GetGlossMedia {
                        gloss(
                            product: MJEGB,
                            where: ${whereClause}
                        ) {
                            id
                            name
                            keywords
                            variants {
                                id
                                signDefinitions {
                                    drawings {
                                        id
                                    }
                                }
                            }
                            photos {
                                id
                            }
                            pictograms {
                                id
                            }
                        }
                    }
                `.replace(' ', ''),
            variables: {},
        };
        return this.client.post(this.baseUrl, queryBody);
    }
}
